import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import DigitizeImg from "../../images/location_new/fold5/img05.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

function Digitize(props) {
    return (
        <div className="digitize_sec p-100" style={{backgroundColor: '#4041ab'}}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <h2>Develop Your Business App in Denver with TekRevol's Team Of Experts</h2>
                        <p>Across the globe, we've directed numerous startups and enterprise-level clients to booming success. Powered by an insatiable drive and firm passion for creating remarkably effective digital products, our creations are accurately designed to catalyze companies' influence on their target markets. As a leading mobile app development company in Denver, we've engaged with innumerable visionaries, sharing our enthusiasm for integrating technologies to birth unusually intuitive and revolutionary solutions for their businesses and audiences. Dive into our portfolio and witness the change.</p>
                        <Link style={{backgroundColor: '#fff' , color:'#4041ab' , border:'1px solid #4041ab'}} 
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact" rel="noopener"
              >
               Book A Consultation Now!
              </Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
                        <LazyLoadImage
                            src={DigitizeImg}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Digitize;